export const RedisSession = {
    set(key, value, ttlMillis = 60000) { // default 1 menit
        const now = new Date();
        const item = {
            data: value,
            expiry: ttlMillis === -1 ? -1 : now.getTime() + ttlMillis
        };
        localStorage.setItem(key, JSON.stringify(item));

        //console.log("saved "+key);
    },

    get(key) {
        const itemStr = localStorage.getItem(key);
        if (!itemStr) return null;

        try {
            const item = JSON.parse(itemStr);
            const now = new Date();

            if (item.expiry !== -1 && now.getTime() > item.expiry) {
                localStorage.removeItem(key);
                return null;
            }
            return item.data;
        } catch (e) {
            return null; // Jaga-jaga jika JSON tidak valid
        }
    },

    delete(key) {
        localStorage.removeItem(key);
    },

    clear() {
        localStorage.clear();
    },

    clearUser() {
        let bulan = sessionStorage.getItem('bulanIdBase');
        let tahun = sessionStorage.getItem('tahunBase');
      
        localStorage.removeItem("pel_all-"+bulan+"-"+tahun+"-page0");
        localStorage.removeItem("pel_belum-"+bulan+"-"+tahun+"-page0");
        localStorage.removeItem("pel_lunas-"+bulan+"-"+tahun+"-page0");
        localStorage.removeItem("pel_lunasnow-"+bulan+"-"+tahun+"-page0");
        localStorage.removeItem("pel_lunas_online-"+bulan+"-"+tahun+"-page0");

    }
};


// WEBPACK FOOTER //
// ./src/globalFunc/redis.js